/** Stored in `registered_users.occupation` — stable values for API/DB. */
export const OCCUPATION_OPTIONS = [
  { value: 'job_salaried', label: 'Job / Salaried' },
  { value: 'business_owner', label: 'Business Owner' },
  { value: 'freelancer', label: 'Freelancer' },
  { value: 'student', label: 'Student' },
  { value: 'homemaker', label: 'Homemaker (Housewife)' },
  { value: 'self_employed', label: 'Self-employed' },
  { value: 'other', label: 'Other' },
];

export const OCCUPATION_VALUES = OCCUPATION_OPTIONS.map((o) => o.value);

export function isValidOccupation(v) {
  return typeof v === 'string' && OCCUPATION_VALUES.includes(v);
}
